import React from 'react';
import axios from 'axios';
import qs from 'qs';
import Buffer from 'buffer';
import oauth from 'axios-oauth-client';

interface Payment {
  return_url: string;
  account?: string;
  pin?: string;
}

class Services{

  /**
   *
   * Payment services
   *
   */

   async getPayment( orderId: any, returnUrl: string, account?: string, pin?: string ) {

     let apiUrl = 'https://api-balony.techcrowd.space/api/payments/'+orderId+'/pay'
     
     let requestBody: Payment = {return_url: returnUrl}

     if(account && pin){
      requestBody.account = account
      requestBody.pin = pin
     }

     const response = await axios.post(apiUrl,
     requestBody,
     {
       headers: {

       }
     })

     const data = await response;

     return data.data;

    }

    async checkPayment( orderId: any ) {

      let apiUrl = 'https://api-balony.techcrowd.space/api/payments/'+orderId+'/check-payment'

      const response = await axios.get(apiUrl,
      {
      }
      )

      const data = await response;

      return data.data;

     }



}

export default Services;
